import { axiosPrivate } from "../api/axiosCore";

export const uploadWaBackup = async (token, channelId, files) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    const formData = new FormData();
    formData.append("channelId", channelId);
    files.forEach((file) => formData.append("files", file));

    const response = await axiosPrivate.post("api/chat-import/wa-backup/upload", formData, {
      // Let the browser set the multipart boundary itself — the instance's
      // default 'application/json' header would break the upload otherwise.
      headers: { "Content-Type": undefined },
    });

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const getWaBackupStatus = async (token, jobId) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    const response = await axiosPrivate.get(`api/chat-import/wa-backup/${jobId}/status`);

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const resolveWaBackupMatch = async (token, jobId, payload) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    const response = await axiosPrivate.post(`api/chat-import/wa-backup/${jobId}/resolve`, payload);

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const confirmWaBackupImport = async (token, jobId, payload) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    const response = await axiosPrivate.post(`api/chat-import/wa-backup/${jobId}/confirm`, payload);

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};
